import SidebarItem from "./SidebarItem";
import { useAuth } from "../contexts/AuthContext";

// Internal evaluation tool restricted to one owner - mirrors the backend
// check in routes/asrComparisonRoutes.js. This only hides the nav link; the
// real access control is server-side, since a hidden link is not security.
const ASR_COMPARISON_OWNER_EMAIL = "arsalanali@hlgsolutions.com";

const Sidebar = ({ collapsed, activePage, setActivePage }) => {
  const { logout, user } = useAuth();
  const isAsrComparisonOwner =
    String(user?.email || "").toLowerCase().trim() === ASR_COMPARISON_OWNER_EMAIL;

  const menuItems = [
    { id: "analytics", label: "Analytics", icon: "bi-pie-chart-fill", path: "/analytics" },
    { id: "volume-alerts", label: "Volume Alerts", icon: "bi-exclamation-triangle-fill", path: "/volume-alerts" },
    { id: "reporting", label: "Reporting", icon: "bi-bar-chart", path: "/reporting" },
    { id: "conversion-report", label: "Conversion Report", icon: "bi-graph-up-arrow", path: "/reports/conversion" },
    { id: "ringba", label: "Ringba Calls", icon: "bi-phone", path: "/calls/ringba" },
    { id: "callgrid", label: "CallGrid Calls", icon: "bi-telephone", path: "/calls/callgrid" },
    { id: "caps", label: "Caps", icon: "bi-graph-up", path: "/caps" },
    { id: "manual-upload", label: "Manual Upload", icon: "bi-upload", path: "/calls/manual-upload" },
    { id: "manual-recordings", label: "Manual Recordings", icon: "bi-mic", path: "/calls/manual" },
    { id: "users", label: "Users", icon: "bi-people", path: "/users" },
    { id: "ask-claude", label: "Ask Claude", icon: "bi-stars", path: "/ask-claude" },
    ...(isAsrComparisonOwner
      ? [
          { id: "asr-comparison", label: "ASR Comparison", icon: "bi-soundwave", path: "/asr-comparison" },
          { id: "shadow-comparison", label: "Shadow Mode", icon: "bi-eye", path: "/shadow-comparison" },
        ]
      : []),
    { id: "logout", label: "Logout", icon: "bi-box-arrow-right", action: logout },
  ];

  const topItems = menuItems.filter((i) => i.id !== "logout");
  const bottomItems = menuItems.filter((i) => i.id === "logout");

  return (
    <aside className="text-white h-100 sticky-top d-flex flex-column"
      style={{
        backgroundColor: "var(--bg-surface)",
        borderRight: "1px solid var(--border)",
        width: collapsed ? "80px" : "220px",
        transition: "width 0.3s",
        overflowY: "auto",
      }}
    >
      <nav className="nav flex-column p-3 flex-grow-1">
        {topItems.map((item) => (
          <SidebarItem
            key={item.id}
            item={item}
            isActive={activePage === item.id}
            onClick={setActivePage}
            collapsed={collapsed}
          />
        ))}
      </nav>

      <nav className="nav flex-column p-3">
        {bottomItems.map((item) => (
          <SidebarItem
            key={item.id}
            item={item}
            isActive={false}
            onClick={(id) => {
              item.action?.();
              setActivePage(id);
            }}
            collapsed={collapsed}
          />
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
